export enum AboConnectUserStatus {
    ACTIVE = 'ACTIVE',
    PROVISIONED = 'PROVISIONED',
    STAGED = 'STAGED',
    DEPROVISIONED = 'DEPROVISIONED',
    ENROLLED = 'ENROLLED',
}
